const types = {
  SHOW: 'app/dialog/SHOW',
  HIDE: 'app/dialog/HIDE',
};

export default types;
